import { createApi } from "../../../../utils/createApi";
import { fetchAllWireGuardTunnels } from "../../../WireGuardTunnels/fetchWireGuardTunnels";
import { WireGuardTunnel } from "../../../WireGuardTunnels/wireGuardTunnelsInterfaces";

export interface SiteCameraAddress {
  camera_name: string;
  /** The address the connector dials (camera or NVR); may be a hostname. */
  ip: string | null;
}

/** Cameras at a site with their saved addresses, every page. */
export const fetchSiteCameraAddresses = async (
  siteId: string | number
): Promise<SiteCameraAddress[]> => {
  const AxiosUI = createApi("");
  const cameras: SiteCameraAddress[] = [];
  // Hard stop so a misbehaving `next` can never loop forever.
  for (let page = 1; page <= 20; page += 1) {
    const response = await AxiosUI.get<{
      results?: { camera_name?: string; ip?: string | null }[];
      next?: string | null;
    }>(`camera/site/?customer__id=${siteId}&page=${page}`);
    (response.data?.results ?? []).forEach((camera) => {
      cameras.push({
        camera_name: camera.camera_name ?? "",
        ip: camera.ip ?? null,
      });
    });
    if (!response.data?.next) break;
  }
  return cameras;
};

/**
 * What resolving a site's tunnels needs: its cameras' addresses and every
 * tunnel the viewer can see (the carrying tunnel may belong to another group,
 * so the group's own list is not enough).
 */
export const fetchSiteTunnelUsageData = async (
  siteId: string | number
): Promise<{ cameras: SiteCameraAddress[]; tunnels: WireGuardTunnel[] }> => {
  const [cameras, tunnels] = await Promise.all([
    fetchSiteCameraAddresses(siteId),
    fetchAllWireGuardTunnels(),
  ]);
  return { cameras, tunnels };
};
